import Offering from '../dto/offering/Offering';
import { i18n } from '../plugin/vue-i18n';
import moment from 'moment/moment';

export default class MessageBuilder {
    static getBookableMessage(offering) {
        if (!(offering instanceof Offering)) {
            return '';
        }

        let $resultString = '';
        if (offering.bookingType === Offering.BOOKING_TYPE_PER_APPOINTMENT) {
            if (offering.bookingStartPerAppointmentAmount && offering.bookingStartPerAppointmentType) {
                $resultString += `${i18n.t('offering.bookingStart')} ${
                    offering.bookingStartPerAppointmentAmount} ${
                    i18n.t(`offeringBookingType.perAppointment.${offering.bookingStartPerAppointmentType}`)} ${
                    i18n.t('offeringBookingType.perAppointment.label')}`;
            }
            if (offering.bookingStartPerAppointmentAmount && offering.bookingEndPerAppointmentAmount) {
                $resultString += '\n';
            }
            if (offering.bookingEndPerAppointmentAmount && offering.bookingEndPerAppointmentType) {
                $resultString += `${i18n.t('offering.bookingEnd')} ${
                    offering.bookingEndPerAppointmentAmount} ${
                    i18n.t(`offeringBookingType.perAppointment.${offering.bookingEndPerAppointmentType}`)} ${
                    i18n.t('offeringBookingType.perAppointment.label')}`;
            }
        } else {
            if (offering.bookingStart) {
                const bookingStart = moment.parseZone(offering.bookingStart);
                $resultString += `${i18n.t('offering.fromStart')} ${
                    bookingStart.format(bookingStart.format('HH:mm') === '00:00' ? 'DD.MM.YYYY' : 'DD.MM.YYYY HH:mm')} `;
            }
            if (offering.bookingEnd) {
                const bookingEnd = moment.parseZone(offering.bookingEnd);
                $resultString += `${i18n.t('offering.toEnd')} ${
                    bookingEnd.format(bookingEnd.format('HH:mm') === '23:59' ? 'DD.MM.YYYY' : 'DD.MM.YYYY HH:mm')}`;
            }
        }
        if ($resultString === '') {
            $resultString = '-';
        }
        return $resultString;
    }
}
